import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import NotFound from "./NotFound";

import Regions from "./Regions";
import SportTypes from "./SportTypes";
import SportVariants from "./SportVariants";
import Parameters from "./Parameters";
import Results from "./Results";

class Advisor extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={Regions} />
        <Route exact path="/regions" component={Regions} />
        <Route exact path="/sport-types" component={SportTypes} />
        <Route exact path="/sport-variants" component={SportVariants} />
        <Route exact path="/parameters" component={Parameters} />
        <Route exact path="/results" component={Results} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
  database: state.database
});

export default connect(
  mapStateToProps,
  null
)(Advisor);
